export default "__VITE_ASSET__DjMnZ9WN__"